export default {
  SWISSPASS: 'SWISSPASS',
  ZERMATT_CARD: 'ZERMATT-CARD',
  SKIDATA: 'SKIDATA',
  RFID: 'RFID',
  BARCODE: 'BARCODE ',
};



// WEBPACK FOOTER //
// ./src/views/skidata/components/ticketLoadings.js